module.exports = __webpack_public_path__ + "static/media/4_k2E_82,14_43,52.335b49d2.png";